import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Text } from '@digsup/components-text';
import { List } from '@digsup/components-list';
import { Icon } from '@digsup/components-icon';
import { Button } from '@digsup/components-button';
import { Collapse } from '@digsup/components-collapse';
import { styles } from './PricingCustom.scss';

const cx = classNames.bind(styles);

export const PricingCustom = ({
  title,
  subtitle,
  label,
  features,
  href,
  className,
  ...props
}) => (
  <div className={cx('c-pricing-plans-custom', className)} {...props}>
    <div className="c-pricing-plans-custom__body">
      <Text
        size="sm"
        fontFamily="serif"
        fontWeight="semibold"
        color="theme-white"
        marginBottom="none">
        {title}
      </Text>
      <Text
        size="2xs"
        fontWeight="semibold"
        color="theme-white"
        marginBottom="none">
        {subtitle}
      </Text>
      <Text size="7xs" color="theme-white" className="u-margin-bottom-large">
        {label}
      </Text>

      <div className="u-margin-bottom-small u-margin-bottom-medium@medium">
        <div className="u-visuallyhidden@medium u-visuallyhidden@large u-visuallyhidden@xlarge">
          <div className="c-pricing-plans-custom__features-collapse">
            <Collapse
              header={<span className="u-color-white">What included?</span>}
              isOpened={false}>
              <div className="u-padding-top-xsmall u-padding-bottom-large">
                <List spacing="large" className="u-display-inline-block">
                  {features.map((item, i) => (
                    <List.Item key={i}>
                      <List
                        spacing="small"
                        display="flex"
                        nowrap
                        valign="center"
                        align="start">
                        <List.Item>
                          <Icon
                            name="checkmark-included"
                            shape="round"
                            className="u-display-block"
                          />
                        </List.Item>
                        <List.Item>
                          <Text color="theme-white">{item}</Text>
                        </List.Item>
                      </List>
                    </List.Item>
                  ))}
                </List>
              </div>
            </Collapse>
          </div>
        </div>
        <div className="u-visuallyhidden@xsmall u-visuallyhidden@small">
          {features && (
            <List spacing="large" className="u-display-inline-block">
              {features.map((item, i) => (
                <List.Item key={i}>
                  <List
                    spacing="small"
                    display="flex"
                    nowrap
                    valign="center"
                    align="start">
                    <List.Item>
                      <Icon
                        name="checkmark-included"
                        shape="round"
                        className="u-display-block"
                      />
                    </List.Item>
                    <List.Item>
                      <Text color="theme-white">{item}</Text>
                    </List.Item>
                  </List>
                </List.Item>
              ))}
            </List>
          )}
        </div>
      </div>
    </div>

    <div className="c-pricing-plans-custom__cta t-danger">
      <Button variant="primary" href={href} width="full">
        Contact Sales
      </Button>
    </div>
  </div>
);

PricingCustom.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  label: PropTypes.string,
  features: PropTypes.array,
  href: PropTypes.string,
  className: PropTypes.string,
};

PricingCustom.defaultProps = {
  className: '',
};
